import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-pin-outline",
  "use": "icon-pin-outline-usage",
  "viewBox": "0 0 28 28",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 28 28\" id=\"icon-pin-outline\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h28v28H0z\" /><path d=\"m14 24.383 5.775-5.775a8.167 8.167 0 1 0-11.55 0L14 24.383Zm0 3.3-7.425-7.425c-4.1-4.1-4.1-10.749 0-14.85 4.1-4.1 10.75-4.1 14.85 0 4.1 4.101 4.1 10.75 0 14.85L14 27.683Zm0-12.516a2.333 2.333 0 1 0 0-4.667 2.333 2.333 0 0 0 0 4.667Zm0 2.333a4.667 4.667 0 1 1 0-9.333 4.667 4.667 0 0 1 0 9.333Z\" fill=\"#B3B3B3\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol